import QuotationDetailsPage from './QuotationDetailsPage';

export default QuotationDetailsPage;
